/**
 * @brisa/shared/observability/analytics
 *
 * Gates condicionais para injeção de Clarity + GA4 scripts.
 * Regra: injeção apenas em PRD + consent granted + ID presente.
 */

export type BrisaEnvValue = 'local' | 'dev' | 'prd' | 'ci';

export interface ClarityGateInput {
  env: BrisaEnvValue | string;
  consentGranted: boolean;
  projectId: string | undefined | null;
}

export function shouldInjectClarity({ env, consentGranted, projectId }: ClarityGateInput): boolean {
  // ADR-014 — property compartilhada DEV+PRD com env-segmentation.
  // Permitir DEV e PRD; bloquear LOCAL e CI (fail-closed).
  if (env !== 'prd' && env !== 'dev') return false;
  if (!consentGranted) return false;
  if (!projectId || projectId.trim() === '') return false;
  return true;
}

export interface GA4GateInput {
  env: BrisaEnvValue | string;
  consentGranted: boolean;
  measurementId: string | undefined | null;
}

export function shouldInjectGA4({ env, consentGranted, measurementId }: GA4GateInput): boolean {
  // ADR-014 — property compartilhada DEV+PRD com env-segmentation.
  // Permitir DEV e PRD; bloquear LOCAL e CI (fail-closed).
  if (env !== 'prd' && env !== 'dev') return false;
  if (!consentGranted) return false;
  if (!measurementId || measurementId.trim() === '') return false;
  return true;
}

export function buildClarityScriptTag(projectId: string): string {
  // Embutido como string; em React o caller usa dangerouslySetInnerHTML.
  return `
(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "${projectId}");
`.trim();
}

export function buildGA4ScriptTag(measurementId: string): string {
  return `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', '${measurementId}', { send_page_view: true });
// Loader: https://www.googletagmanager.com/gtag/js?id=${measurementId}
`.trim();
}
